import { Lightning } from "@lightningjs/sdk";
import { List } from "@lightningjs/ui";
import { Card } from "./Card";
import { FOCUS_TRANSITION, UNFOCUSED_ROW_ALPHA } from "./focus";
export class Row extends Lightning.Component {
    constructor() {
        super(...arguments);
        this.cardType = Card;
        this.List = this.tag("List");
        this._headingHeight = 34;
        this._title = "";
    }
    static _template() {
        return {
            alpha: UNFOCUSED_ROW_ALPHA,
            Title: {
                text: {
                    fontFace: "Roboto",
                    fontSize: 32,
                    fontStyle: "700",
                    precision: 1,
                    h: 34,
                    offsetY: 28,
                    letterSpacing: -0.64,
                    lineHeight: 34,
                    textColor: 0xffffffff,
                },
            },
            List: {
                type: List,
                scroll: (itemWrapper, { index, }) => {
                    // Let's the grab our rail's container.
                    const parent = itemWrapper.parent.parent;
                    // We want to know where on the screen it's positioned.
                    const { core: { 
                    // @ts-expect-error: Lightning typings don't include
                    // `_renderContext`.
                    _renderContext: { px }, }, } = parent;
                    // Let's get a reference to all the children.
                    const { children } = itemWrapper.parent;
                    // Now some calculations for the final child.
                    // @ts-expect-error: Lightning typings don't include `marginRight`.
                    const { marginRight, w, x } = children[children.length - 1];
                    // Get the `x`-coord for the right-hand edge of the final child.
                    const finalChildRightEdge = marginRight + w + x;
                    // We're going to be anchored to one child, let's run through and
                    // calculate for each of them if that's the right one.
                    for (let i = 0; i < children.length; i += 1) {
                        const scroll = -children[i].x;
                        // If we have hit the current child then we anchor to that.
                        if (i === index) {
                            return scroll;
                        }
                        // Otherwise we see if we can already view all remaining cards.
                        if (scroll + finalChildRightEdge + px <= 1920) {
                            return scroll;
                        }
                    }
                    // By default we anchor to the current child.
                    return -itemWrapper.x;
                },
                scrollTransition: {
                    duration: 0.25,
                    timingFunction: "ease-out",
                },
            },
        };
    }
    _focus() {
        this.patch({
            smooth: {
                alpha: [1, FOCUS_TRANSITION],
            },
        });
    }
    _getFocused() {
        return this.List;
    }
    _unfocus() {
        this.patch({
            smooth: {
                alpha: [UNFOCUSED_ROW_ALPHA, FOCUS_TRANSITION],
            },
        });
    }
    addItems(items) {
        const rowItems = Array.isArray(items) ? items : [items];
        return this.List.add(rowItems.map((item) => this.createCard(item)));
    }
    set direction(direction) {
        this.List.patch({
            direction,
        });
    }
    set items(items) {
        this.List.patch({
            items: items.map((item) => this.createCard(item)),
        });
    }
    set headingFontFace(fontFace) {
        this.tag("Title").patch({ text: { fontFace } });
    }
    set headingHeight(height) {
        this._headingHeight = height;
        this.tag("Title").patch({ y: (height - 34) / 2 });
        this.List.patch({ y: this._title ? height + 20 : 0 });
    }
    set scroll(scroll) {
        this.List.patch({
            scroll,
        });
    }
    set scrollTransition(scrollTransition) {
        this.List.patch({
            scrollTransition,
        });
    }
    set title(title) {
        this._title = title;
        this.List.patch({ y: title ? this._headingHeight + 20 : 0 });
        this.tag("Title").patch({
            text: { text: title },
        });
    }
    $getPlaybackCategory() {
        return this._title;
    }
    createCard(item) {
        return Object.assign(Object.assign({}, item), { type: this.cardType });
    }
}
export default Row;
//# sourceMappingURL=Row.js.map